import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = ["aria-hidden"]


const __default__ = {
  name: 'AppAccordionPanel',
}
import { ref } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  showCloseBtn: {
    default: false,
    type: Boolean,
  },
  classes: {
    default: '',
    type: String,
  },
},
  setup(__props) {

const props = __props



const toggleParent = ref<HTMLElement | null>(null)
const isActive = ref(false)

const closeAllPanels = (): void => {
  const parent = toggleParent.value
  const closestParent = parent?.closest('.accordion')

  if (closestParent) {
    const panels = closestParent.querySelectorAll('.panel')
    panels.forEach((element) => {
      element.classList.remove('active')
    })
  }
  isActive.value = false
}

const togglePanel = (): void => {
  isActive.value = !isActive.value
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "toggleParent",
    ref: toggleParent,
    class: _normalizeClass(['accordion','panel', { active: isActive.value }])
  }, [
    _createElementVNode("button", {
      class: "panel-title",
      "aria-expanded": isActive.value.toString(),
      "aria-controls": "panel-content",
      onClick: togglePanel
    }, [
      _createVNode(_unref(FontAwesomeIcon), {
        icon: isActive.value ? ['fas', 'caret-down'] : ['fas', 'caret-right'],
        class: "icon mr-xs-1"
      }, null, 8, ["icon"]),
      _renderSlot(_ctx.$slots, "title")
    ], 8, _hoisted_1),
    _withDirectives(_createElementVNode("div", {
      id: "panel-content",
      class: "panel-content",
      role: "region",
      "aria-hidden": (!isActive.value).toString()
    }, [
      _renderSlot(_ctx.$slots, "content"),
      (__props.showCloseBtn)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn secondary close",
            onClick: closeAllPanels
          }, [
            _renderSlot(_ctx.$slots, "close-button-text")
          ]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2), [
      [_vShow, isActive.value]
    ])
  ], 2))
}
}

})